<template>
    <app-layout>
        <common-content-spacer height="small">
            <patient-top-detail :patientDetails="patientDetails" :insurances="insurancePlans"></patient-top-detail>
            <div class="patient-layout">
                <patient-tab
                    :activeTab="activeTab"
                    :patientId="patientId"
                    @toggle="toggleModal"
                    @open-direct-referral="openDirectReferral"
                ></patient-tab>
                <div class="patient-main">
                    <patient-tab-content
                        :activeTab="activeTab"
                        :patientDetails="patientDetails"
                        :patientId="patientId"
                        @toggle="toggleModal"
                        @update-patient="updatePatient"
                        @close-delete-patient="closeDeletePatientModal"
                        @open-direct-referral="openDirectReferral"
                    ></patient-tab-content>
                </div>
            </div>
            <direct-referral
                v-if="isDirectReferralModalOpen"
                :patientId="patientId ? Number(patientId) : null"
                :activePracticeType="directReferralPracticeType"
                @close="closeDirectReferral"
            ></direct-referral>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PatientTab from 'components/forms/patient/PatientTabs'
    import PatientTabContent from 'components/forms/patient/PatientTabContent'
    import PatientAPI from 'api/PatientAPI'
    import Store from '~/store'
    import PatientTopDetail from 'components/forms/patient/PatientTopDetail'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'

    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            PatientTab,
            PatientTabContent,
            PatientTopDetail,
            DirectReferral,
        },
        data() {
            return {
                insurancePlans: [],
                patientId: null,
                activeTab: 'profile',
                previousActiveTab: 'profile',
                patientDetails: {},
                isLoading: false,
                isDirectReferralModalOpen: false,
                directReferralPracticeType: null,
            }
        },
        methods: {
            openDirectReferral(practiceType) {
                this.directReferralPracticeType = practiceType
                this.isDirectReferralModalOpen = true
            },

            closeDirectReferral() {
                this.isDirectReferralModalOpen = false
                this.directReferralPracticeType = null
            },
            toggleModal(tab) {
                if (tab === 'summary' || tab === 'record-requests-inbox') {
                    return
                }
                if (tab === 'delete-patient') {
                    this.previousActiveTab = this.activeTab
                }
                this.activeTab = tab
            },
            closeDeletePatientModal() {
                this.activeTab = this.previousActiveTab
            },
            getPatientDetails() {
                if (!this.patientId) {
                    this.patientDetails = {}
                    return
                }
                this.isLoading = true
                const userId = this.$auth.getActiveMember()?.id || this.$auth.getUser()?.id
                if (!userId) {
                    this.isLoading = false
                    return
                }
                PatientAPI.getPatientDetails(this.patientId, userId)
                    .then((res) => {
                        this.patientDetails = res || {}
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            updatePatient() {
                this.getPatientDetails()
            },
        },
        watch: {
            '$route.params.id': {
                immediate: true,
                handler(newId) {
                    this.patientId = newId || null
                    if (this.patientId) {
                        this.getPatientDetails()
                    } else {
                        this.patientDetails = {}
                        this.activeTab = 'profile'
                    }
                },
            },
        },
        mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans'] || []
            this.patientId = this.$route.params.id || null
            if (this.patientId) {
                this.getPatientDetails()
            }
        },
    }
</script>
<style lang="css" scoped>
    .patient-layout {
        display: grid;
        grid-template-columns: 260px 1fr;
        gap: 24px;
    }

    .patient-main {
        min-width: 0;
        margin-top: 12px;
    }
</style>
